import "./LoadingScreen.scss";

function LoadingScreen(props) {
  return (
    <div className="main-item">
      <div className="animated-background">
        <div className="background-masker btn-divide-left"></div>
      </div>
      <div className="animated-background">
        <div className="background-masker btn-divide-left"></div>
      </div>
      <div className="animated-background">
        <div className="background-masker btn-divide-left"></div>
      </div>
      <div className="animated-background">
        <div className="background-masker btn-divide-left"></div>
      </div>
      <div className="animated-background">
        <div className="background-masker btn-divide-left"></div>
      </div>
      <div className="animated-background">
        <div className="background-masker btn-divide-left"></div>
      </div>
    </div>
  );
}

export default LoadingScreen;
